<style lang="scss">
  .call-action-button {
    align-items: center;
    background: transparent;
    border: none;
    color: white;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    min-width: 3.5rem;
    padding: 0;
    user-select: none;

    &:disabled,
    &.disabled {
      cursor: default;
      opacity: 0.5;
      pointer-events: none;
    }

    .icon-wrapper {
      align-items: center;
      display: flex;
      font-size: 1rem;
      height: 1rem;
      justify-content: center;
      position: relative;
      width: 1rem;

      // Special record button styles
      &.record-icon {
        .record-indicator {
          align-items: center;
          border: 2px solid white;
          border-radius: 50%;
          display: flex;
          height: 1rem;
          justify-content: center;
          width: 1rem;

          &::before {
            background-color: white;
            border-radius: 50%;
            content: "";
            height: 0.5rem;
            width: 0.5rem;
          }
        }

        &.active {
          .record-indicator {
            border-color: #ea355e;

            &::before {
              animation: flash 2s infinite;
              animation-delay: 1s;
              background-color: #ea355e;
            }
          }
        }
      }

      // Mute icon color when active
      &.mute-icon.active {
        color: #ea355e;
      }
    }

    .label {
      font-size: 0.625rem;
      font-weight: normal;
      line-height: 1;
      text-align: center;
      white-space: nowrap;
    }

    &:hover:not(:disabled):not(.disabled) {
      opacity: 0.85;
    }

    &:active:not(:disabled):not(.disabled) {
      transform: scale(0.95);
    }
  }

  @keyframes flash {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }
</style>

<script>
  let {
    icon = "",
    label = "",
    active = false,
    disabled = false,
    onclick = () => {},
    type = "default", // "default" | "record" | "mute"
    testId = "",
    title = "",
  } = $props();

  const isRecord = $derived(type === "record");
  const isMute = $derived(type === "mute");

  const displayLabel = $derived(() => {
    if (isMute) {
      return active ? "Unmute" : "Mute";
    }
    if (isRecord) {
      return active ? "Stop Rec" : "Start Rec";
    }
    return label;
  });

  const actualLabel = $derived(displayLabel());
</script>

<button
  class="call-action-button"
  class:disabled
  {onclick}
  {disabled}
  data-testid={testId}
  {title}
  type="button"
>
  <div
    class="icon-wrapper"
    class:record-icon={isRecord}
    class:mute-icon={isMute}
    class:active
  >
    {#if isRecord}
      <div class="record-indicator"></div>
    {:else}
      <i class={icon}></i>
    {/if}
  </div>
  <span class="label">{actualLabel}</span>
</button>
